import { activateAgentApi as generatedApi } from '../generated/conversations/activateAgent';

import { getConversationApi } from './getConversation';
import { getConversationsApi } from './getConversations';

const activateAgentApi = generatedApi.enhanceEndpoints({
  endpoints: {
    activateAgent: {
      onQueryStarted: async ({ conversationId }, { dispatch, queryFulfilled }) => {
        const patchList = dispatch(
          getConversationsApi.util.updateQueryData('getConversations', {}, (draft) => {
            const conversation = draft.data.find((c) => c.id === conversationId);

            if (conversation != null) {
              conversation.manualMode = false;
            }
          }),
        );

        const patchSingle = dispatch(
          getConversationApi.util.updateQueryData('getConversation', { conversationId }, (draft) => {
            draft.data.manualMode = false;
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchList.undo();
          patchSingle.undo();
        }
      },
    },
  },
});

export const { useActivateAgentMutation } = activateAgentApi;
